import axios from 'axios'
import { REACT_APP_API } from '../../../config'

export async function getDictionaryTranslationOptions(id) {
  const response = await axios.get(
    `${REACT_APP_API}/dictionary/getTranslationOption/${id}`)
  return response.data
}